module.exports = __webpack_public_path__ + "img/ar.bf30e25d.svg";